import {useState} from "react";
import {Col, Modal, Row} from "react-bootstrap";
import {regularTextStyles, subHeadingStyles} from "../Style";

function DeclarationPopup(props) {
    const [enableButton, setEnableButton] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleClose = () => {
      props.handleChangeValue('declarationPopupShow', false);
    };
  const baseUrl = window.location.origin;
  const eventName = window.location.href.includes('car')
    ? 'carAutosureEvent'
    : window.location.href.includes('quashed')
      ? 'carQuashedEvent'
      : window.location.href.includes('better')
        ? 'carBetterEvent'
        : window.location.href.includes('simplify')
          ? 'carSimplifyEvent'
          : '';
    const handleCloseAndNext = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': `${eventName}`,
          'category': 'Disclosure Consent',
          'virtualUrl': `${baseUrl}/vehicle/step3`,
          'pageTitle': 'Quote',
        });
        handleClose();
        if (!isSubmitting) {
            setIsSubmitting(true);
            props.parentNextStep();
        }
    };

    const onChange = (e) => {
        setEnableButton(e.target.checked);
        props.setParentShowDeclStatement(e.target.checked);
    };

    return (<span style={{fontSize: "10px"}}>
      <Modal
          show={props.parentDeclarationPopupShow}
          onHide={handleClose}
          backdrop="static"
          size="lg"
          keyboard={false}
      >
        <Modal.Header closeButton style={{background: "#E5E7EB"}}>
          <Modal.Title style={subHeadingStyles}>
            {" "}
              Disclosure and declaration
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{background: "white"}}>
          <div style={regularTextStyles}>
            <span className="popup-text">
              <div>
                <b>The Insurer</b>
                <br/>
                <p>
                 This insurance policy is underwritten by Vero Insurance New Zealand Limited (Vero), part of the
Suncorp Group of Companies. Vero has been given an AA- Financial Strength rating by S&P Global Ratings. For more information about Vero’s financial strength rating and solvency margin go to <a
                    href="https://www.vero.co.nz/about-vero/financial-strength.html" style={{color: "black"}}
                    target="_blank"
                    rel="noopener noreferrer">
www.vero.co.nz/about-vero/financial-strength.html</a>.
                     </p>
              </div>
              <div>
                <b>Your Privacy</b>
                <br/>
                <p>
                  You have acknowledged that:
                  <ol>
                    <li>
                     Information you provide to Autosure Insurance Limited (Autosure) will be passed on to and collected by Vero. Autosure is the provider and Vero underwrite this insurance. Vero will use your personal information to assess your application and to manage any insurance provided to you, including assessing any claims made by you.
                    </li>
                    <li>
                     Vero may also obtain personal information about you from, and share it with, Autosure, other insurance companies, Insurance Claims Register Limited (who run a database recording all claims received by participating insurers for the purpose of detecting and preventing insurance fraud), and other third parties that we consider necessary to evaluate and administer your insurance.
                    </li>
                    <li>
                     Where you have an interested party, Vero may notify them if you default on paying premiums under your policy.
                    </li>
                    <li>
                      Failure to provide any personal information requested by Autosure or Vero may result in your application for insurance, or any claims made, being declined.
                    </li>
                    <li>
                      Vero collects, holds and uses your personal information in accordance with its Privacy Statement which can be found at <a
                      href="https://vero.co.nz/privacy"
                      target="_blank" rel="noopener noreferrer"
                      style={{color: "black"}}
                    > vero.co.nz/privacy</a>. Information may be shared with the Suncorp Group of companies. You can request access to, and correction of, your personal information held by Vero by contacting Vero at 48 Shortland Street Auckland, or by emailing {" "}
                        <span
                            className='spanLink' onClick={() => {
                            window.location = "mailto:autosureservice@vero.co.nz"
                        }}
                            style={{
                                color: '#007bff',
                                cursor: 'pointer',
                                textDecoration: 'underline'
                            }}>autosureservice@vero.co.nz</span>.
                    </li>
                    <li>
                     Autosure collects, holds and uses information about you and this insurance in accordance with its Privacy Statement which can be found at <a
                      href="https://autosure.co.nz/privacy-policy"
                      target=" _blank" rel=" noopener noreferrer"
                      style={{color: "black"}}
                    > autosure.co.nz/privacy-policy</a>. Autosure may share your personal information with their service providers and suppliers, their parent company and their group companies. By providing your email address and phone number, you will receive messages from Autosure and Vero about your insurance and, you also consent to Autosure and their related companies sending you marketing messages relating to their products and services, and the products and services of their related group companies, by email and text message. You can request access to, and correction of, your personal information held by Autosure by contacting Autosure at 28 The Warehouse Way, Northcote, Auckland 0627 or via <a
                      href="https://autosure.co.nz/contact-us/"
                      target="_blank" rel="noopener noreferrer"
                    > autosure.co.nz/contact-us.</a>
                    </li>
                  </ol>
               </p>
              </div>

              <div>
                <b>Duty of Disclosure</b>
                <br/>
                <p>
                  You have a legal duty of disclosure that applies at the time you apply for insurance, when you make
changes to your policy and when you make a claim, to tell us everything that a prudent insurer would
want to know when deciding whether to provide you with insurance and if so, on what terms, and
whether your policy will respond to your claim. </p>
                <p>
                 If you are not sure whether you should disclose a particular piece of information, please tell us.</p>
                  <p>If you breach this duty, we may choose to avoid your policy from its beginning. This means that your
policy will be treated as if it never existed and you will have no cover.</p>
              </div>
              <div>
                <b>Declaration</b>
                <br/>
                <p>
                  {" "}
                    By agreeing to proceed, you declare that:
                  <ul>
                    <li>
                      All of the information you have given during this purchase process is correct and complete,
and that all relevant and material information has been disclosed in accordance with your
duty of disclosure; </li>
                    <li>
                     You understand that Autosure is entitled to receive a commission from Vero for arranging this policy; and
                    </li>
                    <li>
                      You agree to accept the terms, conditions, exclusions and definitions of the insurance policy.
                    </li>
                  </ul>
                </p>
              </div>
              <p>
                <label>
                  <input
                      name="agreeCheckbox"
                      type="checkbox"
                      className="form-check-input"
                      checked={enableButton}
                      onChange={onChange}
                      style={{
                        borderColor: '#555',   // Darker border color
                        borderWidth: '2px',    // Make the border thicker (you can increase this value)
                        borderStyle: 'solid',  // Ensure the border is solid
                      }}
                  />

                    <b
                        style={{cursor: "pointer"}}
                        name="agreeCheckbox"
                    >
                    &nbsp; &nbsp; &nbsp; I confirm I understand and agree to this Disclosure and
                    Declaration.
                  </b>
                </label>
              </p>
              <hr/>
            </span>
            <Row>
              <Col>
                <p
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingTop: "32px",
                    }}
                >
                  <button
                      style={{
                          color: "#1851A3",
                          paddingLeft: 25,
                          paddingRight: 25,
                          paddingTop: 13,
                          paddingBottom: 13,
                          background: "white",
                          border: "1px #1851A3 solid",
                          justifyContent: "center",
                          alignItems: "center",
                          display: "inline-flex",
                          wordWrap: "break-word",
                          boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                          borderRadius: 6,
                          width: "100%",
                          maxWidth: "200px",
                      }}
                      onClick={handleClose}
                      className="float-left"
                  >
                    Close
                  </button>
                  <button
                      style={{
                          color: "white",
                          boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                          borderRadius: 6,
                          paddingLeft: 25,
                          paddingRight: 25,
                          paddingTop: 13,
                          paddingBottom: 13,
                          overflow: "hidden",
                          border: "1px white solid",
                          justifyContent: "center",
                          alignItems: "center",
                          display: "inline-flex",
                          width: "100%",
                          maxWidth: "200px",
                          background: enableButton ? "#1851A3" : "#B0C4DE",
                          cursor: "pointer",
                      }}
                      onClick={handleCloseAndNext}
                      disabled={!enableButton}
                      className="float-end"
                  >
                    Next
                  </button>
                </p>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
    </span>
    );
}

export default DeclarationPopup;
